var e="#141414",a="#757575",s="#9e9e9e",b="#e0e0e0",d="#dde2eb";export{d as B,e as F,b as R,a,s as b};
//# sourceMappingURL=colors-953946b8.js.map
